import React, { Component } from "react";
import * as Icon from "react-feather";

import "./tools-tie-strip.css";

import UtilityService from "../../../../services/UtilityService";

class ToolsTieStrip extends Component {
	renderIcon = () => {
		const { ties, waiting } = this.props;
		if (waiting) return <Icon.Circle size={14} />;
		if (ties) return <Icon.CheckCircle size={15} />;
		return <Icon.AlertTriangle size={15} />;
	};

	render() {
		const { waiting, ties, opening, lineCount, movement, reached, note, verdict, waitingFor } = this.props;
		const money = value => UtilityService.formatSignedCurrency({ value });

		if (waiting) {
			return (
				<div className="tk-tie tk-tie--waiting">
					{this.renderIcon()}
					<span>{waitingFor}</span>
				</div>
			);
		}

		return (
			<div className={`tk-tie ${ties ? "tk-tie--ties" : "tk-tie--out"}`}>
				{this.renderIcon()}
				<span className="tk-tie__sum">
					<span>Opening {money(opening)}</span>
					<span className="tk-tie__operator">+</span>
					<span>
						{lineCount} line{lineCount === 1 ? "" : "s"} {money(movement)}
						{note && <span className="tk-tie__note"> {note}</span>}
					</span>
					<span className="tk-tie__operator">=</span>
					<span className="tk-tie__total">{money(reached)}</span>
				</span>
				<span className="tk-tie__verdict">{verdict}</span>
			</div>
		);
	}
}

export default ToolsTieStrip;
